<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <template v-if="!arrangement.ID && loaded">
      <b-row>
        <b-col lg="12">
          <b-alert show>Arrangement inexistant</b-alert>
        </b-col>
      </b-row>
    </template>
    <b-row v-if="loaded && arrangement.ID" class="mx-0 mb-3">
      <b-col>
        <b-card no-body class>
          <b-tabs card content-class="mt-3">
            <b-tab lazy title="Détails">
              <b-row>
                <b-col lg="6">
                  <b-card bg-variant="secondary">
                    <b-row>
                      <b-col lg="6">
                        <h6 class="card-subtitle text-muted mb-2">
                          Status de l'arrangement :
                          {{ status(arrangement.status.value) }}
                        </h6>
                      </b-col>
                      <b-col lg="6">
                        <b-form-select
                          :disabled="!$store.getters.isAdmin"
                          @change="changeArrangement()"
                          v-model="selected_arrangement"
                          :options="select_arrangements"
                        ></b-form-select>
                      </b-col>
                    </b-row>

                    <ul style="padding-left: inherit">
                      <li
                        v-for="(ligne, i) in arrangement.status_text"
                        :key="i"
                        v-html="ligne"
                      ></li>
                    </ul>
                    <hr
                      v-if="
                        $store.getters.isAdmin &&
                        (arrangement.human_intervention ||
                          arrangement.send_mail)
                      "
                    />
                    <b-button
                      variant="danger"
                      class="mr-3"
                      v-if="arrangement.human_intervention"
                      >Intervention humaine</b-button
                    >
                    <b-button
                      class="mr-3"
                      variant="secondary"
                      v-if="$store.getters.isAdmin && arrangement.send_mail"
                      @click="$bvModal.show('modal-courrier')"
                      >Courrier</b-button
                    >

                    <b-button
                      v-if="$store.getters.isSuperAdmin"
                      @click="supprimer"
                      variant="danger"
                      >Supprimer</b-button
                    >
                    <b-button
                      v-if="
                        $store.getters.isAdmin &&
                        arrangement.status.value == 'proposal'
                      "
                      @click="rompre"
                      variant="info"
                      class="ml-3"
                      >Rompre</b-button
                    >
                    <b-button
                      v-if="
                        $store.getters.isAdmin &&
                        arrangement.status.value == 'proposal'
                      "
                      @click="reajuster"
                      class="ml-3"
                      >Réajuster</b-button
                    >
                    <b-button
                      v-if="
                        $store.getters.isAdmin &&
                        arrangement.status.value == 'breached'
                      "
                      @click="nouvel_arrangement"
                      variant="success"
                      class="ml-3"
                    >
                      Créer un nouvel arrangement
                    </b-button>
                    <b-modal
                      id="modal-courrier"
                      size="xxl"
                      title-class="text-center"
                      hide-footer
                      hide-header
                    >
                      <Courrier
                        @close="closeCourrierModal()"
                        :mandat="arrangement.mandat"
                        :courrier_typeID="arrangement.courrier_type"
                      ></Courrier>
                    </b-modal>
                  </b-card>
                </b-col>
                <b-col lg="6">
                  <b-card bg-variant="secondary" sub-title="Informations">
                    <p>{{ arrangement.resume }}</p>
                    <b-table
                      striped
                      small
                      hover
                      :items="informations"
                      thead-class="d-none"
                      class="mb-0"
                    >
                    </b-table>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col lg="12">
                  <b-card bg-variant="secondary">
                    <b-row>
                      <b-col lg="6">
                        <h6 class="card-subtitle text-muted mb-2">Paiements</h6>
                        <b-table
                          id="paymentsTable"
                          striped
                          small
                          hover
                          show-empty
                          :items="arrangement.payments_debiteur"
                          :fields="payments_fields"
                          :tbody-tr-class="rowClass"
                        >
                          <template #empty>
                            <h6 class="text-center text-danger mt-3">
                              Pas encore de paiement pour cet arrangement
                            </h6>
                          </template>
                        </b-table>
                      </b-col>
                      <b-col lg="6">
                        <h6 class="card-subtitle text-muted mb-2">
                          Plan de remboursement
                        </h6>
                        <b-table
                          striped
                          small
                          hover
                          :items="arrangement.payments.payement"
                          :fields="remboursement_fields"
                          @row-hovered="highlight_payment"
                        >
                          <template v-slot:cell(icon)="data">
                            <b-icon
                              v-if="data.item.color !== 'danger'"
                              :icon="data.item.icon"
                              :variant="data.item.color"
                            ></b-icon>
                            <b-icon-arrow-down-circle-fill
                              @click="readjust_modal(data.index)"
                              class="readjust-icon"
                              v-else-if="$store.getters.isAdmin"
                              variant="info"
                            ></b-icon-arrow-down-circle-fill>
                          </template>
                        </b-table>
                        <b-modal
                          id="modal-readjust"
                          @ok="readjust"
                          @cancel="$bvModal.hide('modal-readjust')"
                          cancel-title="Annuler"
                        >
                          <template #modal-title>
                            Réajuster à partir de
                          </template>
                          <b-row>
                            <mh-input
                              mhClass="col-12"
                              field="date"
                              :table="adjust_settlement"
                            >
                            </mh-input>
                          </b-row>
                        </b-modal>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab lazy :title="'Rappels (' + arrangement.rappels.length + ')'">
              <b-card bg-variant="secondary" sub-title="Rappels">
                <b-table
                  v-if="arrangement.rappels.length > 0"
                  class="mb-0"
                  small
                  id="rappelsTable"
                  striped
                  hover
                  :fields="rappelsFields"
                  :items="arrangement.rappels"
                >
                </b-table>
                <b-alert v-else show
                  >Pas de rappels pour cet arrangement</b-alert
                >
              </b-card>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import settlements from "@/services/settlements.js";
import MhInput from "@/components/MhInput.vue";
import Courrier from "@/components/Courrier";
export default {
  name: "settlement",
  props: {
    id: [String, Number],
    edit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MhInput,
    Courrier,
  },
  data() {
    return {
      loaded: false,
      arrangement: {},
      informations: [],
      items: [],
      select_arrangements: [],
      selected_arrangement: null,
      selected_section: null,
      refreshPaiements: 0,
      adjust_settlement: {
        date: {
          error: false,
          label: "Repousser la date à",
          type: "date",
          value: null,
        },
      },
      payments_fields: [
        {
          key: "date",
          label: "Date",
          sortable: true,
          class: "text-center",
          formatter: (value) => this.toDate(value),
        },
        {
          key: "montant",
          label: "Montant",
          sortable: true,
          class: "text-right",
          formatter: (value) => this.euros(value),
        },
        {
          key: "subtotal",
          label: "Sous-total",
          sortable: false,
          class: "text-right",
          formatter: (value) => this.euros(value),
        },
      ],
      remboursement_fields: [
        {
          key: "icon",
          label: "",
          class: "text-center",
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
          class: "text-center",
          formatter: (value) => this.toDate(value),
        },
        {
          key: "mensualité",
          label: "Échéance",
          sortable: true,
          class: "text-right",
          formatter: (value) => (value ? this.euros(value) : "Ajusté"),
        },

        {
          key: "amortissement",
          label: "Amortissement",
          sortable: true,
          class: "text-right",
          formatter: (value) => this.euros(value),
        },
        {
          key: "base",
          label: "Principal",
          sortable: true,
          class: "text-right",
          formatter: (value) => this.euros(value),
        },
        {
          key: "solde",
          label: "Solde",
          sortable: true,
          class: "text-right",
          formatter: (value) => this.euros(value),
        },
        {
          key: "intérêt",
          label: "Intérêts",
          sortable: true,
          class: "text-right",
          formatter: (value) => this.euros(value),
        },
      ],
      rappelsFields: [
        {
          key: "date",
          label: "Date",
          formatter: (value) => this.toDate(value),
          sortable: true,
        },
        {
          key: "montantDu",
          label: "Montant en retard",
          formatter: (value) => this.twoDigits(value) + " €",
          sortable: true,
        },
        {
          key: "numero",
          label: "Numéro",
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    closeCourrierModal() {
      this.$bvModal.hide("modal-courrier");
      this.load();
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.highlighted) return "table-success";
    },
    highlight_payment(item) {
      document
        .querySelectorAll("#paymentsTable tbody tr")
        .forEach((el, index) => {
          if (index == item.index) {
            this.arrangement.payments_debiteur[index].highlighted = true;
            el.className = "table-success";
          } else if (this.arrangement.payments_debiteur[index]) {
            this.arrangement.payments_debiteur[index].highlighted = false;
            el.className = "";
          }
        });
    },
    nouvel_arrangement() {
      this.$router.push({
        name: "newSettlement",
        params: { id: this.arrangement.mandatID.value },
      });
    },
    reajuster() {
      settlements.readjust(this.id).then((response) => {
        if (response.data.success) {
          this.$router.push({
            name: "newSettlement",
            params: { id: this.arrangement.mandatID.value },
          });
        }
      });
    },
    readjust_modal(index) {
      this.$bvModal.show("modal-readjust");
      this.adjust_settlement.date.value = this.arrangement.payments.payement[
        index + 1
      ]
        ? this.arrangement.payments.payement[index + 1].date
        : this.arrangement.payments.payement[index];
      this.selected_section = index;
    },
    readjust() {
      let index = this.selected_section;
      settlements
        .readjust_manual(this.id, index, this.adjust_settlement.date.value)
        .then(() => {
          this.load();
        });
    },
    changeArrangement() {
      this.id = this.selected_arrangement;
      this.$router.push({ path: `/settlement/${this.selected_arrangement}` });
      this.load();
    },
    supprimer() {
      this.$bvModal.msgBoxConfirm("Êtes-vous sûr?").then((ok) => {
        if (!ok) return;
        settlements.delete(this.id).then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("Arrangement supprimé", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            this.$router.push({
              name: "warrantEdit",
              params: { id: this.arrangement.mandat.ID.value },
            });
          }
        });
      });
    },
    rompre() {
      settlements.rompre(this.id).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Arrangement rompu", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          this.load();
        }
      });
    },
    load() {
      settlements.get(this.id).then((response) => {
        this.arrangement = response.data;
        this.select_arrangements = [];
        console.log(this.arrangement);
        this.arrangement.arrangements.records.forEach((el) => {
          this.select_arrangements.push({
            value: el.ID,
            text:
              this.toDate(el.date) +
              (el.date_end !== "0000-00-00"
                ? " - " + this.toDate(el.date_end)
                : "") +
              " (" +
              this.status(el.status) +
              ")",
          });
        });
        this.arrangement.payments_debiteur.forEach((el) => {
          el.highlighted = false;
        });
        this.selected_arrangement = this.arrangement.ID.value;
        this.loaded = true;
        this.informations = [
          {
            label: "Date de création",
            value: this.toDate(this.arrangement.date_encodage.value),
          },
          {
            label: "Date du premier paiement",
            value: this.toDate(this.arrangement.date.value),
          },
          {
            label: "Solde à la création",
            value:
              this.twoDigits(this.arrangement.soldeWhenRegistered.value) + " €",
          },
          {
            label: "Principal à la création",
            value:
              this.twoDigits(this.arrangement.principalWhenRegistered.value) +
              " €",
          },
          {
            label: "Résumé de l'arrangement",
            value: this.arrangement.resume,
          },
        ];
        this.items = [
          {
            text: "Gestion",
            to: { name: "home" },
          },
          {
            text: "Mandats",
            to: { name: "warrants" },
          },
          {
            text:
              "Mandat n° " +
              this.arrangement.mandat.ID.value +
              " (" +
              this.arrangement.mandat.creancier.nom_soc.value +
              " vs " +
              this.arrangement.mandat.debiteur.nom_complet.value +
              ")",
            to: {
              name: "warrantView",
              params: { id: this.arrangement.mandat.ID.value },
            },
          },
          {
            text: "Arrangement n°" + this.arrangement.ID.value,
            active: true,
          },
        ];
      });
    },

    toDate(d) {
      return DateTime.humanDate(d);
    },
    euros(value) {
      if (value == 0) {
        return "";
      }
      return value.toLocaleString("fr-BE", {
        style: "currency",
        currency: "EUR",
      }); // this.twoDigits(value) + ' €';
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
    status(value) {
      switch (value) {
        case "proposal":
          return "proposition";
        case "breached":
          return "rompu";
        case "stopped":
          return "arrêté";
        case "adjusted":
          return "ajusté";
        default:
          return "N/A";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.readjust-icon {
  &:hover {
    cursor: pointer;
  }
}
</style>